import {
  LOCAL_STORAGE_KEY_COLLECTION_DAYS_LIST,
  LOCAL_STORAGE_KEY_COLLECTION_PHONE_NUMBER,
  LOCAL_STORAGE_KEY_COLLECTION_PICKUP_INSTRUCTIONS,
  LOCAL_STORAGE_KEY_COLLECTION_PICKUP_LOCATION,
  LOCAL_STORAGE_KEY_COLLECTION_TIME_RANGE,
} from '../constants'

// Collection form values now come from the backend. These keys were previously
// written for users who consented to cookies. Keep this cleanup through
// 2027-09-30 so infrequent visitors still have the leftovers removed. Calling
// removeItem when a key is already gone is a no-op, so it is safe on every launch.
const DEPRECATED_COLLECTION_FORM_LOCAL_STORAGE_KEYS = [
  LOCAL_STORAGE_KEY_COLLECTION_DAYS_LIST,
  LOCAL_STORAGE_KEY_COLLECTION_TIME_RANGE,
  LOCAL_STORAGE_KEY_COLLECTION_PICKUP_LOCATION,
  LOCAL_STORAGE_KEY_COLLECTION_PHONE_NUMBER,
  LOCAL_STORAGE_KEY_COLLECTION_PICKUP_INSTRUCTIONS,
]

export function removeDeprecatedCollectionFormLocalStorageKeys() {
  if (typeof window === 'undefined') return

  try {
    for (const key of DEPRECATED_COLLECTION_FORM_LOCAL_STORAGE_KEYS) {
      window.localStorage.removeItem(key)
    }
  } catch {
    // Storage can be unavailable. The app no longer reads these keys.
  }
}
